import isMobile from 'ismobilejs';

export const device = isMobile();
